import classNames from 'classnames';
import { PW_MARKER_SELECTOR } from 'utilities/consts/variable-types.js';
import { MarkerOptions } from '../../components/map/themes/pill-theme.js';

export const MarkerV2Wrapper = ({
  className,
  children,
  themeProps,
}: {
  className?: string;
  children: React.ReactNode;
  themeProps?: MarkerOptions;
}) => {
  if (themeProps) {
    return (
      <div
        data-testid={PW_MARKER_SELECTOR}
        className={classNames('Pill pill--padding svg-fill-font-color', className)}
        style={{
          backgroundColor: themeProps.background,
          borderColor: themeProps.border,
          color: themeProps.text,
        }}
      >
        {children}
      </div>
    );
  }
  return (
    <div data-testid={PW_MARKER_SELECTOR} className={classNames('Pill pill--padding', className)}>
      {children}
    </div>
  );
};
